import type { SimilarJobOffers } from '~/business/JobOffer/getSimilarJobOffers';
import type { Translator } from '~/utils/translations/buildTranslate';

export const getSimilarOffersTitle = (
  t: Translator,
  { isSameJob }: SimilarJobOffers,
  { title, city }: { title: string; city?: string | null },
) => {
  // an external offer may come without an address
  if (!city) {
    return t('similar_offers.title_without_city');
  }
  return isSameJob
    ? t('similar_offers.title_with_location', { title, city })
    : t('similar_offers.title_nearby', { city });
};
